
export const clientVersion = "2.1.3";

export const clientInfoVersion = "2.1.3.Sha.bc3b4a3471cf1d07fe64876728af648d17bb8f21";

